import {AfterViewInit, Component, ElementRef, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {BaseComponent} from '../../../../../models/base/base-component';
import ResizeObserver from 'resize-observer-polyfill';
import {BehaviorSubject} from 'rxjs';
import {GuideInsightsViewModel} from './guide-insights-view-model';

@Component({
  selector: 'app-guide-insights',
  templateUrl: './guide-insights.component.html',
  styleUrls: ['./guide-insights.component.scss'],
  providers: [GuideInsightsViewModel],
})
export class GuideInsightsComponent extends BaseComponent
  implements OnInit, AfterViewInit, OnChanges, OnDestroy {

  @ViewChild('graphContainer') private graphContainer: ElementRef;
  private observeContainer: ResizeObserver;
  private dimensions = new BehaviorSubject<[number, number]>([0, 0]);
  public dimensions$ = this.dimensions.asObservable();

  constructor(
    public vm: GuideInsightsViewModel
  ) {
    super();
  }

  ngOnInit(): void {
    this.setupViews();
  }

  setupViews() {
  }

  ngAfterViewInit() {
    this.setupBindings();
  }

  setupBindings() {
    this.observeGraphContainer();
  }

  ngOnChanges(changes: SimpleChanges) {
  }

  observeGraphContainer() {
    this.observeContainer = new ResizeObserver((entries, _) => {
      for (const entry of entries) {
        const cr = entry.contentRect;
        if (cr.width > 0) {
          this.dimensions.next([cr.width, 400]);
        } else {
          this.dimensions.next([0, 0]);
        }
      }
    });
    this.observeContainer.observe(this.graphContainer.nativeElement);
  }

  ngOnDestroy() {
    this.observeContainer?.disconnect();
    this.destroy();
  }
}
